import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { LoginService } from '../../Services/login.service';
import { apiEndPoints } from '../../api/apiEndPoint';
import { SharedService } from '../../Services/shared.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    ToastrModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  submitted = false;
  isLoading = false;
  loginForm: FormGroup;
  loginData: any;
  userType: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private loginService: LoginService,
    private toastr: ToastrService,
    private sharedService: SharedService
  ) {
    // Initialize the form group for login
    this.loginForm = this.fb.group({
      userName: ['', Validators.required],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z]).{6,}$'),
        ],
      ],
    });
  }

  ngOnInit(): void {}

  showPassword: boolean = false;
 
togglePassword() {
  this.showPassword = !this.showPassword;
}

  get f() {
    return this.loginForm.controls;
  }

  // ------------------ Form submission logic ------------------ //

  loginSubmit() {
    this.submitted = true;
    this.isLoading = true;

    if (this.loginForm.valid) {
      const reqBody = {
        userName: this.loginForm.value.userName,
        password: this.loginForm.value.password,
        userType: 'Admin',
        platform: 'Android',
      };

      this.loginService.postLoginApi(reqBody, apiEndPoints.login).subscribe({
        next: (response: any) => {
          const allowedUserTypes = [6, 7, 8, 11];
          const userTypeFromResponse = Number(response.body?.details?.userType);

          if (
            response.statusText === 'Successfull' &&
            allowedUserTypes.includes(userTypeFromResponse)
          ) {
            const loginData = response.body.details;
            this.userType = loginData?.userType;

            const token = response.body.details.jwtToken; 
            localStorage.setItem('jwtToken', token);

            const refreshToken = response.body.details.refreshToken;
            localStorage.setItem('refreshToken', refreshToken);

            // Store login data
            this.sharedService.setLoginData(loginData);

            this.toastr.success('Login successful', 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            });

            if (this.userType == 11) {
              this.router.navigate(['/baldia-approval']);
            } else {
              this.router.navigate(['/registered-users']);
            }
          } else {
            localStorage.removeItem('jwtToken');
            this.toastr.error('Invalid User', 'Error', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            });
            this.isLoading = false;
          }
        },
        error: () => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.isLoading = false;
        },
      });
    } else {
      this.loginForm.markAllAsTouched();
      this.isLoading = false;
    }
  }
}

